<template>
  <AppWelcome @complete="handleComplete" />
</template>

<script setup>
import AppWelcome from '@/components/AppWelcome'
const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}

const handleComplete = () => {
  // Close the modal when welcome/onboarding flow is completed
  close()
}
</script>
